<template>
	<div :class="isPc == true ? 'manager warp' : ''">
		<div>
			<div v-if="isPc == true" class="breadcrumb greyfont warp">
				<ul>
					<li>{{ title }}</li>
				</ul>
			</div>
			<!-- pc导航 -->
			<div v-if="isPc == true" class="horizontal-container">
				<div class="scroll-wrapper" ref="scroll">
					<div class="scroll-content bluefont">
						<div class="scroll-item"
							:style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
							v-for="(item, index) in tabar_list" @click="tabarchange(index,item.css)" :key="index">
							<p>{{ item }}</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 手机导航 -->
			<div v-if="isPc == false" class="mob-tabar">
				<ul class="warp-mob bluefont">
					<li :style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
						@click="tabarchange(index,item.css)" v-for="(item, index) in tabar_list" :key="index">
						{{ item }}
					</li>
				</ul>
			</div>
			<div v-if="css == 1">
				<div v-if="datas" :class="isPc == true ? 'article' : 'article-mob warp-mob'">
					<div class="articleTitle bluefont">{{ datas.title }}</div>
					<div class="articleText">
						<div v-html="datas.textcontent"></div>
					</div>
				</div>
			</div>
			<div v-else>
				<div v-if="data" class="manager_cont">
					<ul v-if="isPc == true" class="manager_cont_list">
						<li @click="getpage(item.id)" class="manager_cont_list_item" v-for="item in data"
							:key="item.tiem">
							<div class="manager_cont_list_item_date bluefont">
								<h1>
									{{ item.createtime.substring(8, 10) }}
									<p>/{{ item.createtime.substring(5, 7) }}</p>
								</h1>
							</div>
							<div class="manager_cont_list_item_text">
								<h2>{{ item.title }}</h2>
								<p>{{ item.introduction }}</p>
							</div>
						</li>
					</ul>
					<ul v-if="isPc == false" class="manager_cont_list-mob warp-mob">
						<li @click="getpage(item.id)" class="manager_cont_list_item" v-for="item in data"
							:key="item.tiem">
							<div class="manager_cont_list_item_date bluefont">
								<h1>
									{{ item.createtime.substring(8, 10) }}
									<p>/{{ item.createtime.substring(5, 7) }}</p>
								</h1>
								<h2>{{ item.title }}</h2>
								<span>></span>
							</div>
							<div class="manager_cont_list_item_text">
								<p>{{ item.introduction }}</p>
							</div>
						</li>
					</ul>
				</div>
				<div v-if="isPc == true && data" class="manager_pagination warp">
					<el-pagination @current-change="handleCurrentChange" background :current-page="currentPage"
						layout="prev, pager, next" :total="data_length" :page-size="page_size"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BScroll from '@better-scroll/core';
	export default {
		name: 'WebLijinhospitalManagequality',

		data() {
			return {
				isPc: true,
				pid: 0,
				title: '',
				tabar_list: [],
				tabar_list_cur: 0,
				data: null,
				datas: null,
				currentPage: 1,
				data_length: 0,
				page_size: 5,
				css: 0,
				List: [{
						name: '医院文化',
						path: '/aboutHospital'
					},
					{
						name: '职工天地',
						path: '/manageHospital'
					},
					{
						name: '医疗保险',
						path: '/aboutHospital'
					},
					{
						name: '药事管理',
						path: '/aboutHospital'
					},
					{
						name: '医院感染管理',
						path: '/aboutHospital'
					},
					{
						name: '信息公开',
						path: '/aboutHospital'
					},
					{
						name: '投诉电话',
						path: '/aboutHospital'
					},
					{
						name: '医院文化',
						path: '/aboutHospital'
					},
					{
						name: '职工天地',
						path: '/manageHospital'
					},
					{
						name: '医疗保险',
						path: '/aboutHospital'
					},
					{
						name: '药事管理',
						path: '/aboutHospital'
					},
					{
						name: '医院感染管理',
						path: '/aboutHospital'
					},
					{
						name: '信息公开',
						path: '/aboutHospital'
					},
					{
						name: '投诉电话',
						path: '/aboutHospital'
					},
					{
						name: '医院文化',
						path: '/aboutHospital'
					},
					{
						name: '职工天地',
						path: '/manageHospital'
					},
					{
						name: '医疗保险',
						path: '/aboutHospital'
					},
					{
						name: '药事管理',
						path: '/aboutHospital'
					},
					{
						name: '医院感染管理',
						path: '/aboutHospital'
					},
					{
						name: '信息公开',
						path: '/aboutHospital'
					},
					{
						name: '投诉电话',
						path: '/aboutHospital'
					}
				]
			};
		},

		mounted() {
			if ('id' in this.$route.query) {
				this.pid = this.$route.query['id'];
				this.title = this.$route.query['name'];
			} else {
				this.pid = 0;
				this.key = this.$route.query['key'];
				this.title = '搜索结果';
			}
			if (document.body.clientWidth <= 820) {
				this.isPc = false;
				console.log(this.isPc);
			} else {
				this.isPc = true;
				console.log(this.isPc);
			}
			this.getdata(0);
			this.init();
		},

		methods: {
			handleCurrentChange(pageNumber) {
				this.currentPage = pageNumber;
				this.getdata(this.tabar_list_cur);
			},
			tabarchange(index, css) {
				this.currentPage = 1;
				this.css = css
				this.data = null
				this.datas = null
				this.tabar_list_cur = index;
				this.getdata(this.tabar_list_cur);
			},
			init() {
				this.bs = new BScroll(this.$refs.scroll, {
					scrollX: true,
					probeType: 3 // listening scroll event
				});
				this.bs.on('scrollStart', () => {
					console.log('scrollStart-');
				});
				this.bs.on('scroll', () => {
					console.log('scrolling-');
				});
				this.bs.on('scrollEnd', () => {
					console.log('scrollingEnd');
				});
			},
			// 内容页
			getpage(e) {
				this.$router.push({
					path: '/content',
					query: {
						title: this.tabar_list[this.tabar_list_cur],
						id: e
					}
				});
			},
			getdata(i) {
				let _t = this;
				if (_t.pid == 0) {
					_t.tabar_list[0] = '搜索结果';
					this.$axios({
							url: 'http://www.ljxzxyy.cn/api/index/article',
							params: {
								search: _t.key,
								num: this.page_size,
								page: this.currentPage
							}
						})
						.then((res) => {
							//请求成功

							console.log('article', res.data);
							this.data = res.data.data.list;
							this.data_length = res.data.data.count;
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				} else {
					this.$axios({
							url: 'http://www.ljxzxyy.cn/api/index/article',
							params: {
								pid: _t.pid
							}
						})
						.then((res) => {
							//请求成功
							let plist = res.data.data;
							let index_arr = [];
							let cat = [];
							for (var i1 = 0; i1 < plist.length; i1++) {
								_t.tabar_list[i1] = plist[i1]['nickname'];
								index_arr[i1] = plist[i1]['id'];
								cat[i1] = plist[i1]['css'];
							}
							let category_id = index_arr[i];
							this.css = cat[i]
							this.$axios({
									url: 'http://www.ljxzxyy.cn/api/index/article',
									params: {
										category_id: category_id,
										num: this.page_size,
										page: this.currentPage
									}
								})
								.then((res) => {
									console.log('csssss', this.css)
									//请求成功
									if (this.css == 0) {
										console.log(123333333333333333333333)
										this.data = res.data.data.list;
										this.data_length = res.data.data.count;
									} else {
										console.log('csssssssssssssss', res.data.data.list)
										if (res.data.data.list.length > 0) {
											this.$axios({
													url: 'http://www.ljxzxyy.cn/api/index/article',
													params: {
														id: res.data.data.list[0].id
													}
												})
												.then((res) => {
													//请求成功
													console.log('article_neirong', res.data);
													this.datas = res.data.data;
												})
												.catch((error) => {
													//请求失败
													console.log('article', error);
												});
										} else {
											this.datas = null;
										}
									}

								})
								.catch((error) => {
									//请求失败
									console.log('article', error);
								});
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				}
			}
		}
	};
</script>

<style lang="scss" scoped></style>